// Lightweight GA4 helper. gtag() is injected in public/index.html.

const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

let metaFirstView = true;

export const trackPageView = (path, title) => {
  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
  // index.html already fired the first Meta PageView; track later in-app navigations only
  if (metaFirstView) { metaFirstView = false; return; }
  if (typeof window.fbq === "function") window.fbq("track", "PageView");
};

export const trackViewItem = (product) => {
  gtag("event", "view_item", {
    currency: "INR",
    value: product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1,
      },
    ],
  });
};

const fbqTrack = (...args) => {
  if (window.fbq) { window.fbq(...args); }
};

export const trackMetaViewContent = (product, unitPrice) => {
  fbqTrack("track", "ViewContent", {
    content_ids: [product.id], content_name: product.name, content_type: "product",
    value: Number(unitPrice), currency: "INR",
  });
};

export const trackMetaAddToCart = (product, qty, unitPrice) => {
  fbqTrack("track", "AddToCart", {
    content_ids: [product.id], content_name: product.name, content_type: "product",
    value: Number(unitPrice) * qty, currency: "INR",
  });
};

export const trackAddToCart = (product, qty = 1) => {
  gtag("event", "add_to_cart", {
    currency: "INR",
    value: product.price * qty,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: qty,
      },
    ],
  });
};

export const trackMetaInitiateCheckout = (items, subtotal) => {
  fbqTrack("track", "InitiateCheckout", {
    content_ids: items.map((i) => i.id), num_items: items.reduce((n, i) => n + i.qty, 0),
    value: Number(subtotal), currency: "INR",
  });
};

export const trackBeginCheckout = (items, subtotal) => {
  gtag("event", "begin_checkout", {
    currency: "INR",
    value: subtotal,
    items: items.map((i) => ({
      item_id: i.id,
      item_name: i.name,
      price: i.price,
      quantity: i.qty,
    })),
  });
};

export const trackPurchase = (order) => {
  const key = `venus_fb_purchase_${order.id}`;
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    const items = order.items || [];
    fbqTrack("track", "Purchase", {
      content_ids: items.map((i) => i.product_id || i.id), num_items: items.reduce((n, i) => n + i.qty, 0),
      value: Number(order.total), currency: "INR",
    }, { eventID: order.id });
  }
  gtag("event", "purchase", {
    transaction_id: order.id,
    currency: order.currency || "INR",
    value: order.total,
    shipping: order.shipping || 0,
    items: (order.items || []).map((i) => ({
      item_id: i.product_id,
      item_name: i.name,
      price: i.price,
      quantity: i.qty,
    })),
  });
};

export const trackSignUp = (method = "email") => {
  gtag("event", "sign_up", { method });
};

export const trackLogin = (method = "email") => {
  gtag("event", "login", { method });
};
